(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
    const applyLabels = (root = document) => {
      root.querySelectorAll('.accelerated-checkout-block').forEach((block) => {
        const label = block.dataset.checkoutLabel;
        if (!label) return;

        block.querySelectorAll('.shopify-payment-button__button--unbranded').forEach((button) => {
          if (button.dataset.checkoutLabel === label) return;

          button.textContent = `${label} \u2192`;
          button.setAttribute('aria-label', label);
          button.dataset.checkoutLabel = label;
        });
      });
    };

    window.alinaApplyAcceleratedCheckoutLabels = applyLabels;
    applyLabels();

    if (window.alinaAcceleratedCheckoutLabelObserver) return;

    window.addEventListener('DOMContentLoaded', () => applyLabels());
    document.addEventListener('shopify:section:load', (event) => applyLabels(event.target));

    window.alinaAcceleratedCheckoutLabelObserver = new MutationObserver(() => applyLabels());
    window.alinaAcceleratedCheckoutLabelObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.biottaImageBlockSync === true) return;
    window.biottaImageBlockSync = true;

    const BLOCK_SELECTOR = '[data-image-sync-block]';
    const SOURCE_SELECTOR = '[data-image-sync-source="true"]';
    const TARGET_SELECTOR = '[data-image-sync-target="true"]';
    const EMPTY_SELECTOR = '[data-image-sync-empty="true"]';
    const MEDIA_SELECTOR = '[data-image-sync-media]';
    const TARGET_CONTENT_SELECTOR = '[data-image-sync-placeholder], [data-image-sync-clone="true"]';
    const MOBILE_ONLY_CLASSES = ['hidden--desktop', 'desktop:hidden'];

    const getSectionRoot = (element) => {
      return element.closest('[id^="shopify-section-"]') || element.closest('.shopify-section') || document;
    };

    const getNearestSource = (target, sectionRoot) => {
      const blocks = Array.from(sectionRoot.querySelectorAll(BLOCK_SELECTOR));
      const targetIndex = blocks.indexOf(target);

      return blocks
        .filter((block) => block !== target && block.matches(SOURCE_SELECTOR) && block.querySelector(MEDIA_SELECTOR))
        .sort((a, b) => {
          const aIndex = blocks.indexOf(a);
          const bIndex = blocks.indexOf(b);
          return Math.abs(aIndex - targetIndex) - Math.abs(bIndex - targetIndex);
        })[0];
    };

    const isMobileOnlyTarget = (target, sectionRoot) => {
      if (target.matches(TARGET_SELECTOR)) return true;

      let element = target.parentElement;

      while (element && element !== sectionRoot) {
        if (MOBILE_ONLY_CLASSES.some((className) => element.classList.contains(className))) return true;
        element = element.parentElement;
      }

      return false;
    };

    const applyTargetImageSettings = (clone, target) => {
      const imageStyle = target.dataset.imageSyncStyle || '';
      const customClasses = (target.dataset.imageSyncCustomClass || '').split(/\s+/).filter(Boolean);

      clone.classList.remove('image-block__media--hover');
      clone.querySelectorAll('.image-block__image--hover').forEach((image) => image.remove());

      clone.querySelectorAll('img').forEach((image) => {
        image.removeAttribute('id');
        if (imageStyle) image.setAttribute('style', imageStyle);
        customClasses.forEach((className) => image.classList.add(className));
      });
    };

    const syncTarget = (target) => {
      if (!(target instanceof HTMLElement)) return;

      const sectionRoot = getSectionRoot(target);
      const source = getNearestSource(target, sectionRoot);
      const sourceMedia = source?.querySelector(MEDIA_SELECTOR);
      const targetContent = target.querySelector(TARGET_CONTENT_SELECTOR);

      if (!(sourceMedia instanceof HTMLElement) || !(targetContent instanceof HTMLElement)) return;

      const clone = sourceMedia.cloneNode(true);
      clone.setAttribute('data-image-sync-clone', 'true');
      applyTargetImageSettings(clone, target);
      targetContent.replaceWith(clone);
    };

    const syncAll = (root = document) => {
      const candidates =
        root instanceof Element && root.matches(`${TARGET_SELECTOR}, ${EMPTY_SELECTOR}`)
          ? [root]
          : Array.from(root.querySelectorAll(`${TARGET_SELECTOR}, ${EMPTY_SELECTOR}`));

      candidates
        .filter((target) => isMobileOnlyTarget(target, getSectionRoot(target)))
        .forEach(syncTarget);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncAll());
    } else {
      syncAll();
    }

    document.addEventListener('shopify:section:load', (event) => syncAll(event.target));
    document.addEventListener('shopify:block:select', (event) => syncAll(getSectionRoot(event.target)));
  })();
  } catch(e) { console.error(e); }
})();

})();
